// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"e66b3c82","453":"f4905858"}[chunkId] + ".chunk.js";
};